import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Fetch from 'utils/fetch'
import Dialog from 'material-ui/Dialog'
import { SelectBox, Toggle } from 'components/uikit-adapter/index'
import Loading from 'components/center-loading'
import intl from 'react-intl-universal'

import './material-form.css'
import { formatErrorMessage } from 'utils/handle-error';
import { usesReturnableAssets } from 'utils/validations-general-settings'
import { useMaterialFormData } from './useMaterialFormData'
import Button from 'components/button'
import Input from 'components/input'

const MaterialForm = ({ editMode, handleClose, handleFeedback, handleRefresh, idEdit, open, profileAdminOrMasterData }) => {
  const {
    loadingStates,
    isLoading,
    data,
    actions
  } = useMaterialFormData();
  const [requestCount, setRequestCount] = useState(0);
  const [material, setMaterial] = useState({
    Insumo: {},
    Carteira: {},
    Familia: {},
    FamiliaRotulada: {},
    UnidadeArredondamento: {},
    AtivoGiro: false
  });

  useEffect(() => {
    loadFormData();
  }, []);

  const loadFormData = async () => {
    try {
      if (editMode) {
        await searchMaterialById();
      } else {
        await actions.fetchMaterials();
      }

      await actions.fetchRoundingUnities();
      await actions.fetchBudgets();
    } catch (error) {
      console.error('Error loading initial form data:', error);
    }
  }

  const searchMaterialById = () => {
    return new Promise((resolve, reject) => {
      const idMaterial = idEdit;
      handleFetch();

      Fetch.get(`/material/detail/${idMaterial}`)
        .then((response) => {
          proccessData(response.data)
          actions.fetchFamiliesByMaterialGroup(response.data.IdCarteira);
          actions.fetchLabeledFamiliesByFamily(response.data.IdFamilia)
        })
        .then(() => resolve())
        .catch((e) => proccessErro(e))
        .finally(() => handleFetch(false))
    })
  }

  const proccessData = (data) => {
    const { Id, Numero, Nome, IdCarteira, NomeCarteira, IdFamilia, NomeFamilia,
      IdFamiliaRotulada, NomeFamiliaRotulada, IdUnidadeArredondamento, NomeUnidadeArredondamento, AtivoGiro } = data;
    
    setMaterial({
      Id: Id,
      Insumo: {
        Numero: Numero,
        Nome: Nome,
      },
      Carteira: {
        Id: IdCarteira,
        Descricao: NomeCarteira
      },
      Familia: {
        Id: IdFamilia,
        Nome: NomeFamilia
      },
      FamiliaRotulada: {
        Id: IdFamiliaRotulada,
        Descricao: NomeFamiliaRotulada
      },
      UnidadeArredondamento: {
        Id: IdUnidadeArredondamento,
        Descricao: NomeUnidadeArredondamento
      },
      AtivoGiro: AtivoGiro
    });
  };

  const updateAtivoGiro = value => {
    setMaterial(prevState => ({
      ...prevState,
      AtivoGiro: value
    }))
  }

  const updateMaterialSelectValue = (prop, value) => {
    setMaterial(prevState => ({
      ...prevState,
      Id: value.Id,
      Insumo: {
        ...prevState.Insumo,
        Numero: value.Number
      },
      UnidadeArredondamento: {
        Id: value.RoundingUnitId
      }
    }))
  }

  const updateBudgetSelectValue = (prop, value) => {
    setMaterial(prevState => ({
      ...prevState,
      Carteira: {
        ...prevState.Carteira,
        Id: value
      },
      Familia: {
        ...prevState.Familia,
        Id: '',
        Nome: ''
      },
      FamiliaRotulada: {
        ...prevState.FamiliaRotulada,
        Id: '',
        FamiliaRotulada: ''
      }
    }));
    actions.fetchFamiliesByMaterialGroup(value);
  }

  const updateFamilySelectValue = (prop, value) => {
   setMaterial(prevState => ({
      ...prevState,
      Familia: {
        ...prevState.Familia,
        Id: value
      },
      FamiliaRotulada: {
        ...prevState.FamiliaRotulada,
        Id: '',
        FamiliaRotulada: ''
      }
    }));
    actions.fetchLabeledFamiliesByFamily(value);
  }

  const updateRotuladedFamilySelectValue = (prop, value) => {
    setMaterial(prevState => ({
      ...prevState,
      FamiliaRotulada: {
        ...prevState.FamiliaRotulada,
        Id: value
      }
    }))
  }

  const updateUnidadeArredondamentoSelectValue = (value) => {
    setMaterial(prevState => ({
      ...prevState,
      UnidadeArredondamento: {
        ...prevState.UnidadeArredondamento,
        Id: value
      }
    }))
  }

  const save = () => {
    const { Numero } = material.Insumo

    if (validateFields()) {
      const IdFamiliaRotulada = material.FamiliaRotulada.Id
      const IdUnidadeArredondamento = material.UnidadeArredondamento.Id
      const AtivoGiro = material.AtivoGiro

      const materialSave = {
        MaterialNumber: Numero,
        LabeledFamilyId: IdFamiliaRotulada,
        RoundingUnitId: IdUnidadeArredondamento,
        ReturnableAssets: AtivoGiro
      }

      handleFetch();

      Fetch.patch('/materials', materialSave)
        .then(handleRefresh)
        .then(() => handleFeedback(`${intl.get('feedbacks.register')} ${!editMode ? intl.get('feedbacks.saved') : intl.get('feedbacks.updated')} ${intl.get('feedbacks.withSuccess')}`))
        .catch((e) => proccessErro(e))
        .finally(() => handleFetch(false))
    }
  }

  const validateFields = () => {
    let isValid = true

    if (!material.Id) {
      handleFeedback(intl.get('feedbacks.messageMaterialForm1'))
      isValid = false
    }
    else if (!material.Carteira.Id) {
      handleFeedback(intl.get('feedbacks.messageMaterialForm2'))
      isValid = false
    }
    else if (!material.Familia.Id) {
      handleFeedback(intl.get('feedbacks.messageMaterialForm3'))
      isValid = false
    }
    else if (!material.FamiliaRotulada.Id) {
      handleFeedback(intl.get('feedbacks.messageMaterialForm4'))
      isValid = false
    }
    else if (!material.UnidadeArredondamento.Id) {
      handleFeedback(intl.get('feedbacks.messageMaterialForm5'))
      isValid = false
    }

    return isValid
  }

  const proccessErro = (exception) => {
    try {
      const erro = formatErrorMessage(exception)
      handleFeedback(erro)
    } catch (e) {
      handleFeedback(intl.get('feedbacks.serverError'))
    }
  }

  const handleFetch = (isFetching = true) => {
    setRequestCount(prevState => isFetching ? prevState.requestCount + 1 : prevState.requestCount - 1);
  }

    return (
      <div>
        <Loading isLoading={isLoading || requestCount > 0} />
        <Dialog
          title={editMode ? intl.get('master-data.materials.actions.editMaterial') : intl.get('master-data.materials.actions.ableMaterial')}
          contentStyle={{ width: '600px', transform: 'translate(0px, 30px)' }}
          open={open}
          autoScrollBodyContent
        >
          {editMode &&
            <Input
              disabled
              label={intl.get('commons.material')}
              name='Material'
              value={`${parseInt(material.Insumo.Numero)} - ${material.Insumo.Nome}`}
              className="input"
            />
          }
          {
            !editMode &&
            <SelectBox
              required
              name='Material'
              label={intl.get('commons.material')}
              placeholder={intl.get('commons.material')}
              valueKey='Id'
              labelKey='MaterialSearch'
              value={material.Id}
              options={data.materials}
              onChange={value => updateMaterialSelectValue('Material', value)}
              disabled={!profileAdminOrMasterData}
              searchable
              openOnFocus
              isLoading={loadingStates.materials}
              data-testid='material-form-selectbox-material'
            />
          }
          <SelectBox
            required
            name='Carteira'
            label={intl.get('commons.wallet')}
            placeholder={intl.get('commons.wallet')}
            valueKey='Id'
            labelKey='Description'
            value={material.Carteira.Id}
            options={data.budgets}
            onChange={value => updateBudgetSelectValue('Carteira', value.Id)}
            disabled={!profileAdminOrMasterData}
            searchable
            openOnFocus
            isLoading={loadingStates.budgets}
            data-testid='material-form-selectbox-wallet'
          />
          <SelectBox
            required
            name='Familia'
            label={intl.get('commons.family')}
            placeholder={intl.get('commons.family')}
            valueKey='Id'
            labelKey='Name'
            value={material.Familia.Id}
            options={data.families}
            onChange={value => updateFamilySelectValue('Familia', value.Id)}
            disabled={!profileAdminOrMasterData}
            searchable
            openOnFocus
            isLoading={loadingStates.families}
            data-testid='material-form-selectbox-family'
          />
          <SelectBox
            required
            name='FamiliaRotulada'
            label={intl.get('commons.labeledFamily')}
            placeholder={intl.get('commons.labeledFamily')}
            valueKey='Id'
            labelKey='Description'
            value={material.FamiliaRotulada.Id}
            options={data.labeledFamilies}
            onChange={value => updateRotuladedFamilySelectValue('FamiliaRotulada', value.Id)}
            disabled={!profileAdminOrMasterData}
            searchable
            openOnFocus
            isLoading={loadingStates.labeledFamilies}
          />
          <div className='selectBoxVisionMaterial'>
            <SelectBox
              required
              name='UnidadeArredondamento'
              label={intl.get('master-data.general.table.actions.editProvider.roundedUnity')}
              placeholder={intl.get('master-data.general.table.actions.editProvider.roundedUnity')}
              valueKey='Id'
              labelKey='Descricao'
              value={material.UnidadeArredondamento != undefined ? material.UnidadeArredondamento.Id : null}
              options={data.roundingUnities}
              onChange={value => updateUnidadeArredondamentoSelectValue(value.Id)}
              disabled={!profileAdminOrMasterData}
              searchable
              openOnFocus
              isLoading={loadingStates.roundingUnities}
            />
          </div>
          {usesReturnableAssets() &&
            <div style={{ width: '99%' }}>
              <label className="label-style">{intl.get('master-data.general-configuration.generalSettings')}</label>
              <div className="container__general-form" style={{ display: 'flex', alignItems: 'center', minHeight: '30px' }}>
                <span style={{ whiteSpace: 'nowrap' }}>
                  <label className="title-ativo-giro">{intl.get('master-data.general.table.actions.editProvider.ativoGiro')}</label>
                </span>
                <Toggle
                  name="ativo-giro"
                  value={material.AtivoGiro}
                  onChange={value => updateAtivoGiro(value.checked)}
                  thumbSwitchedStyle={{ backgroundColor: 'var(--color-action-default)' }}
                  trackSwitchedStyle={{ backgroundColor: 'var(--color-neutral-200)' }}
                />
              </div>
            </div>
          }
          <div className='footer-dialog-buttons-material'>
            <Button
              buttonType="default"
              value={intl.get('geral.buttonsDefault.cancel')}
              onClick={() => handleClose()}
              className="button"
            />
            {profileAdminOrMasterData &&
              <Button
                buttonType="primary"
                value={intl.get('geral.buttonsDefault.save')}
                className="button"
                onClick={save}
              />
            }
          </div>
        </Dialog>
      </div>
    )
}

MaterialForm.propTypes = {
  editMode: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  idEdit: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  profileAdminOrMasterData: PropTypes.func.isRequired
}

export default MaterialForm
